import { defineComponent as _defineComponent } from 'vue'
import EmployeeAvatar from '@/components/employee/EmployeeAvatar.vue';
import BubbleIcon from '@/components/interface/BubbleIcon.vue';
import Chevron from '@/components/interface/Chevron.vue';
import { AvatarSizes } from '@/lib/enum/AvatarSizes';
import { Icon } from '@/lib/enum/Icon';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { presentShiftTimes } from '@/lib/schedule-v2/scheduleV2Functions';
import {
  shiftJobRoleIsVisible,
  totalShiftBreakMinutes,
} from '@/lib/schedule-v2/shiftV2Functions';
import { isAssigned } from '@/lib/schedule-v2/shiftV2Status';
import store from '@/store';
import { getEntity, getEntityName } from '@/util/entityFunctions';
import { presentMinutes } from '@/util/presenters';
import { computed, onMounted, ref, watch } from 'vue';
import { Employee, JobRole, ScheduleSettings, Shift } from '../../../../api/v1';
import DateSquareV2 from './DateSquareV2.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftSummary',
  props: {
    shift: null,
    showDate: { type: Boolean, default: true },
    count: { default: 1 },
    clickable: { type: Boolean, default: false },
    showEmployee: { type: Boolean, default: false },
    toggled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { shift: Shift, showDate: boolean, count: number, clickable: boolean, showEmployee: boolean, toggled: boolean }





const locations = realtimeQuery(Entity.Location).fetch();
const jobRoles = realtimeQuery(Entity.JobRole).fetch();
const shiftSwaps = ref(realtimeQuery(Entity.ShiftSwap).empty());
const employees = ref(realtimeQuery(Entity.Employee).empty());

const scheduleSettings = computed<ScheduleSettings>(
  () => store.state.settings.scheduleSettings,
);
const initialising = computed<boolean>(
  () => locations.isLoading || jobRoles.isLoading || employees.value.isLoading,
);

const jobRole = computed<JobRole>(() =>
  getEntity(props.shift.jobRoleId, jobRoles.data),
);

const employee = computed<undefined | Employee>(() => {
  if (
    !props.showEmployee ||
    !props.shift.employeeId ||
    employees.value.isLoading
  ) {
    return undefined;
  }
  return getEntity(props.shift.employeeId, employees.value.data) as Employee;
});

watch(
  () => scheduleSettings.value,
  (settings) => {
    if (settings.shiftSwappingEnabled) {
      shiftSwaps.value = realtimeQuery(Entity.ShiftSwap)
        .where('shiftId', 'eq', props.shift.id)
        .fetch();
    }
  },
);

onMounted(() => {
  if (props.showEmployee && props.shift.employeeId) {
    employees.value = realtimeQuery(Entity.Employee)
      .where('id', 'eq', props.shift.employeeId)
      .fetch();
  } else {
    employees.value = realtimeQuery(Entity.Employee).empty(false);
  }
});

return { __sfc: true,props, emit, locations, jobRoles, shiftSwaps, employees, scheduleSettings, initialising, jobRole, employee, EmployeeAvatar, BubbleIcon, Chevron, AvatarSizes, Icon, presentShiftTimes, shiftJobRoleIsVisible, totalShiftBreakMinutes, isAssigned, getEntityName, presentMinutes, DateSquareV2 }
}

})